/**
 * Force Cart Update - Ensures cart counts update immediately
 */

(function() {
  'use strict';

  let isSubmitting = false;

  function forceUpdateCartCounts() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update all possible cart count selectors immediately
        const selectors = [
          '.cart-count',
          '.cart-qty', 
          '.cart-items',
          '.header-cart .cart-qty',
          '.icon-cart-header .cart-qty',
          '.cart-total span:first-child'
        ];
        
        selectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(el => {
            el.textContent = cart.item_count;
            el.style.opacity = '0.5';
            setTimeout(() => {
              el.style.opacity = '1';
            }, 100);
          });
        });
        
        console.log('Cart count updated to:', cart.item_count);
      })
      .catch(error => console.error('Force cart update failed:', error));
  }

  // Override all add to cart forms
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();
      
      // Prevent multiple submissions
      if (isSubmitting) {
        return;
      }
      
      isSubmitting = true;
      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"], .add-to-cart');
      
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Could not add item to cart');
        }
        return response.json();
      })
      .then(data => {
        // Force immediate update
        forceUpdateCartCounts();
        
        // Update again after 500ms to ensure it sticks
        setTimeout(forceUpdateCartCounts, 500);
        
        // Show success message
        const toast = document.createElement('div');
        toast.textContent = 'Item added to cart!';
        toast.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #28a745;
          color: white;
          padding: 10px 20px;
          border-radius: 4px;
          z-index: 10001;
        `;
        document.body.appendChild(toast);
        setTimeout(() => toast.remove(), 3000);
      })
      .catch(error => {
        console.error('Add to cart failed:', error);
        
        // Show error message
        const toast = document.createElement('div');
        toast.textContent = 'Could not add item. Please try again.';
        toast.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #dc3545;
          color: white;
          padding: 10px 20px;
          border-radius: 4px;
          z-index: 10001;
        `;
        document.body.appendChild(toast);
        setTimeout(() => toast.remove(), 3000);
      })
      .finally(() => {
        if (button) {
          button.disabled = false;
          button.textContent = 'Add to Cart';
        }
        
        // Reset submission flag after delay
        setTimeout(() => {
          isSubmitting = false;
        }, 1000);
      });
    }
  });

  // Force update on page load
  document.addEventListener('DOMContentLoaded', forceUpdateCartCounts);

  // Only update when cart changes, not on interval
  document.addEventListener('cart:updated', forceUpdateCartCounts);
  document.addEventListener('cart:item:added', forceUpdateCartCounts);
  document.addEventListener('cart:item:removed', forceUpdateCartCounts);

  // Expose globally
  window.ForceCartUpdate = { forceUpdateCartCounts };

})();